
import { Options, Vue } from "vue-class-component";
import Header from "@/components/Header.vue";
import Message from "@/components/Message.vue";
import { closePage, openPage } from "@/utils/patientLoggerPage";
import StorageService from "@/services/StorageService";

@Options({
  components: {
    Header,
    Message
  }
})
export default class Messages extends Vue {
  viewName = "Messages";
  patientLoggerPageId: number | undefined;
  user: any = null;
  private storageService = new StorageService();

  async created() {
    this.user = this.storageService.getUser();
  }

  async mounted() {
    this.patientLoggerPageId = await openPage(
      this.viewName,
      this.user.patientsId
    );
  }

  async beforeUnmount() {
    if (this.patientLoggerPageId && this.storageService.getUser()) {
      await closePage(this.patientLoggerPageId, this.user.patientsId);
    }
  }
}
